<template>
  <div class="certifications page-content">
    <section class="module__header">
      <h2 class="module__header__title">经营资质</h2>
      <p class="module__header__subtitle">Business qualifications</p>
    </section>
    <section class="certifications-container">
      <section
        class="certification"
        v-for="(item, index) in certifications"
        :key="item.key"
        :class="{
          'non-first-row': index > 1,
        }"
      >
        <section class="img-container" @click="onPreview(item)">
          <img
            src="https://static.soyoung.com/sy-pre/17e766lq3yjjh-1682662200711.png"
            alt=""
            class="preview-icon"
          />
          <img class="main-image" :src="item.content" alt="" />
        </section>
        <section class="title">{{ item.name }}</section>
      </section>
    </section>
    <section class="img-preview" :class="{ hide: !previewVisible }">
      <section class="fixed-mask"></section>
      <section
        class="img-preview__body"
        @click="previewVisible = !previewVisible"
      >
        <img v-if="previewImg" :src="previewImg" alt="" />
      </section>
    </section>
  </div>
</template>

<script>
import { get } from "lodash";
export default {
  name: "certifications",
  data() {
    return {
      certifications: [],
      previewImg: null,
      previewVisible: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/base/official-site/anonymous/basic-disclosure/list?type=2")
        .then((res) => {
          const records = get(res, "data");
          if (Array.isArray(records)) {
            this.certifications = records;
          }
        })
        .catch((error) => {});
    },
    onPreview(item) {
      this.previewVisible = true;
      this.previewImg = item.content;
    },
  },
};
</script>

<style lang="less">
.certifications {
  .certifications-container {
    width: 100%;
    display: flex;
    align-items: top;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 106px;
    box-sizing: border-box;
    .certification {
      box-sizing: border-box;
      width: 50%;
      width: 444px;
      &.non-first-row {
        padding-top: 50px;
      }
      .img-container {
        width: 444px;
        height: 322px;
        box-sizing: border-box;
        border: 10px solid rgba(0, 68, 193, 0.1);
        overflow: hidden;
        cursor: pointer;
        position: relative;
        img.main-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: left top;
        }
        img.preview-icon {
          position: absolute;
          right: 4px;
          bottom: 4px;
          width: 24px;
          height: 24px;
        }
      }
      .title {
        padding-top: 14px;
        font-size: 18px;
        line-height: 26px;
        text-align: center;
        color: #121519;
      }
    }
  }
  .img-preview {
    .fixed-mask {
      cursor: pointer;
    }
    .img-preview__body {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 999999;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
@media all and (max-width: 1200px) {
  .certifications {
    .certifications-container {
      padding: 0 15px;
      box-sizing: border-box;
      .certification {
        width: 100%;
        height: auto;
        .img-container {
          width: 100%;
          height: auto;
        }
      }
      .certification + .certification {
        margin-top: 24px;
      }
    }
  }
}
</style>
